<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="QuotationTaskEditTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" :table_height_adjust="-6" :loading_width="40"
        :hb_table_class="'hb_table_qttable_edit_class1'" @on_query="on_query" @on_input="detail_on_input"
        :show_toolbar_button="[0, 0, 0, 0, 0]" only_text="显示全部" @only_methods="only_methods" @tool_invoke="tool_invoke" tableref="1d47e478361648ae917ad81a9f7e5d5c">
        <template #query>
          报价申请单号：
          <el-select size="small" v-model="QuotationTaskNum" filterable remote reserve-keyword
            :remote-method="QTRemoteMethod" clearable @clear="QTRemoteMethod('')" @focus="QTRemoteMethod('')"
            placeholder="请输入报价申请编号关键词" class="w-10">
            <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
          </el-select>
          物料编号：<el-input clearable size="small" style="width: 150px" v-model="ItemId"></el-input>
        </template>
        <template #toolbar>
          <el-popover placement="right" title="提示" width="300" trigger="hover" style="border-color: red;">
            <p>1、暂无操作数据可能是因为您没有勾选;</p>
            <p>2、默认显示报价单未审批的报价申请;</p>
            <p>3、报价单审批为"未生成"代表该报价申请还未流转到报价单审批处;</p>
            <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
          </el-popover>
          <el-checkbox label="仅退回" v-model="onlyRefused" class="ml-2" @change="only_methods"></el-checkbox>
        </template>
        <template #operation>
          <el-tag type="danger" effect="plain">
            <h6>*除已经审批通过的报价单外，所有审批后的报价申请的价格都可以在此调整！！！</h6>
          </el-tag>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
            :label="$t('common.save')" class="ml-2"></QueryButton>
        </template>
      </TableMain>
    </BaseContainer>

  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController";
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController";
import * as SalesOrderController from "../../controllers/sd/SalesOrderController";
import BaseContainer from "../components/BaseContainer";
import QueryButton from "../components/base/QueryButton";
import TableMain from "../components/table/TableMain";

export default {
  components: {
    BaseContainer,
    TableMain,
    QueryButton
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "quote_apply",
      },
      fields: _.cloneDeep(QuotationTaskController.fields.order_tracking),
      QuotationTaskNum: "",
      ItemId: "",
      QTOptions: [],
      all_role_users: [],
      isBusy: false,
      onlyRefused: false
    };
  },
  async created() {
    await this.getAllRoleUsers();
  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName();
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0];
      }
    },
    //#region 查询
    async only_methods() {
      await this.on_query(this.$refs.QuotationTaskEditTable1.SetData, false);
    },
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true;
        set_data([]);
      }

      let p = {};
      if (this.QuotationTaskNum != "") {
        p.QuotationTaskNum = this.QuotationTaskNum;
      }
      if (this.ItemId != "") {
        p.ItemId = this.ItemId
      }
      let _result = await QuotationTaskController.methods.getDetailDataBySql(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = [];
        let dt = _.orderBy(_.filter(_result[0], (t) => t.closed != 2), ["id"], ["desc"]);
        if (this.onlyRefused)
          dt = _.filter(dt, { isOrderRefused: 1 });
        if (!this.$refs.QuotationTaskEditTable1.only_value)
          dt = _.filter(dt, { fcCheckSQOrderApproved: false });
        _.each(dt, (t) => {
          let _index = _.findIndex(
            this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccount }
          );
          if (_index > -1) {
            if (!t.isWeightedCostAllConfirm)
              t.fcGetSQOrderApprover = null;
            this.getApprover(t);
            _list.push(t);
          }
        })
        set_data(_list);
      }
      this.isBusy = false;
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSQOrderApprover",
        "SQOrderApprover",
        t.fcCheckSQOrderApproved,
        t.isWeightedCostAllConfirm
      );
    },
    ///获取报价申请编号
    async getKvQuoteTask(query = '') {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "kv");
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum };
        });
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      await this.getKvQuoteTask(query);
    },
    ///明细行输入事件
    detail_on_input(data) {
      if (data.field.key == "Price") {
        this.getWOTaxAmount(data.item);
        data.item.Price_WOTax = _.round(data.item.Price_WOTax, 6)
        data.item.GrossProfitMargin = 0
        if (data.item.Price_WOTax > 0)
          data.item.GrossProfitMargin = _.round(((data.item.Price_WOTax - data.item.TotalCost) * 100 / data.item.Price_WOTax), 2)
      }
    },
    getWOTaxAmount(item) {
      let _price = item.Price;
      if (item.Currency != 'CNY') {
        let m = _.find(this.$store.state.biz_data.baseData.ExchangeRate, { dispFromCurrencyCode: item.Currency })
        if (m) _price = _price * (m.ExchangeRate / 100);
      }
      item.Price_WOTax = _price;
      if (item.InclTax == '是') {
        let tg = _.find(this.$store.state.biz_data.baseData.TaxGroupHeading, { TaxGroup: item.TaxGroup, dataAreaId: item.dataAreaId });
        item.Price_WOTax = _.round((_price / (1 + tg.SEI_TaxValue / 100)), 6);
      }
    },
    //#endregion

    //#region 保存
    async Detail_SaveData(cb) {
      //数据验证
      let msg = "", p = { add: [], edit: [], clear_state: false, quote_task: { data: [], clear_state: false } };
      let detail_data = this.$refs.QuotationTaskEditTable1.GetSelectedItems();
      if (detail_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(null);
        return;
      }
      _.each(detail_data, (t) => {
        if (msg == "" && t.fcCheckSQOrderApproved) {
          msg = t.QuotationTaskNum + "报价单已经审批，不能执行该操作！"
        }
        else {
          let m = {};
          m.id = t.id;
          m.Price = parseFloat(t.Price);
          m.Price_WOTax = parseFloat(t.Price_WOTax);
          m.PriceDescription = t.PriceDescription;
          m.SQOrderDescription = "";
          m.is_price_update = true
          // let isExists = _.some(p.quote_task.data, t.id);
          // if (t.isOrderRefused && !isExists) {
          //   p.quote_task.data.push(t.id);
          // }
          p.edit.push(m);
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }
      if (p.quote_task.data.length > 0) {
        await this.$confirm('检测到选择中有退回数据，是否将退回数据更新至待审批状态？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '是',
          cancelButtonText: '否'
        }).then(() => {
          p.quote_task.clear_state = true;
        }).catch(action => {
          p.quote_task.clear_state = false;
        });
      }
      let rt = await QuotationTaskController.methods.saveDetailData(p);
      if (rt) {
        await this.on_query(this.$refs.QuotationTaskEditTable1.SetData, false);
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true, true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        };
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data);
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data);
      }
    },
    //#endregion
  },
};
</script>
<style>
.hb_table_qttable_edit_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 265rem;
}
</style>
